import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, Home, Smile } from 'lucide-react';
export function HeroSection() {
  const badges = [{
    icon: FileText,
    text: 'PDF'
  }, {
    icon: Zap,
    text: 'Acceso inmediato'
  }, {
    icon: Home,
    text: 'Electricidad del hogar'
  }, {
    icon: Smile,
    text: 'Explicado fácil'
  }];
  return <section className="relative pt-4 pb-0 md:pt-6 md:pb-0 overflow-hidden px-4 bg-gradient-to-b from-brand-50 to-white" data-id="element-90">
      {/* Background soft glow */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-brand-200/40 rounded-full blur-[120px] pointer-events-none" data-id="element-91" />
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-accent-100/50 rounded-full blur-[100px] pointer-events-none" data-id="element-92" />

      <div className="max-w-5xl mx-auto relative z-10 text-center" data-id="element-93">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-94">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-brand-100 text-brand-600 border border-brand-200 text-sm font-bold mb-3 shadow-sm" data-id="element-95">
            PUNTO EBOOK
          </span>
        </motion.div>

        <motion.h1 className="md:text-5xl lg:text-6xl tracking-tight mb-1 text-gray-900 font-bold text-[30px] leading-tight" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} data-id="element-96">
          MEGA PACK <br data-id="element-97" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-500 to-brand-400" data-id="element-98">
            ELECTRICIDAD DESDE CERO
          </span>
        </motion.h1>

        <motion.p className="text-xl md:text-2xl text-gray-600 mb-6 font-medium" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} data-id="element-99">
          Todos los arreglos eléctricos de tu casa, resueltos.
        </motion.p>

        {/* Product Image */}
        <motion.div className="relative max-w-2xl mx-auto mb-6" initial={{
        opacity: 0,
        scale: 0.9,
        rotate: -2
      }} animate={{
        opacity: 1,
        scale: 1,
        rotate: 0
      }} transition={{
        duration: 0.7,
        delay: 0.25
      }} data-id="element-100">
          <div className="absolute inset-0 bg-gradient-to-tr from-brand-300/15 to-accent-300/15 rounded-full blur-3xl transform scale-90" data-id="element-101" />
          <img src="https://cdn.magicpatterns.com/uploads/ji6Rc7EzJysANisfHqRHUT/WhatsApp_Image_2026-04-01_at_16.15.19-removebg-preview.png" alt="Mega Pack Electricidad en Casa" className="relative z-10 w-full max-w-[200px] mx-auto h-auto drop-shadow-2xl animate-float" data-id="element-102" />
        </motion.div>

        <motion.div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} data-id="element-103">
          <a href="#pricing" className="w-full sm:w-auto px-8 py-4 bg-brand-500 hover:bg-brand-600 text-white font-bold rounded-2xl transition-all transform hover:scale-105 shadow-[0_8px_30px_rgba(236,72,153,0.3)] text-lg flex items-center justify-center gap-2" data-id="element-104">
            Descargalo Ahora
            <Zap className="w-5 h-5" data-id="element-105" />
          </a>
        </motion.div>

        <motion.p className="text-gray-500 mb-5 max-w-xl mx-auto text-[14px]" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.35
      }} data-id="element-106">
          Sin llamar a un electricista. Sin miedo. Paso a paso. El sistema
          completo para aprender electricidad del hogar desde cero y poder
          resolver enchufes, luces, problemas eléctricos e instalaciones
          básicas.
        </motion.p>

        <motion.div className="flex flex-wrap justify-center gap-3 mb-5" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.45
      }} data-id="element-107">
          {badges.map((badge, index) => <div key={index} className="flex items-center gap-2 bg-white border border-gray-100 shadow-sm px-4 py-2 rounded-xl text-sm font-semibold text-gray-600" data-id="element-108">
              <badge.icon className="w-4 h-4 text-brand-500" data-id="element-109" />
              {badge.text}
            </div>)}
        </motion.div>
      </div>
    </section>;
}